export const ArrowIconUpward = () => (
  <svg
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    transform="rotate(180deg)"
  >
    <g id="Vector">
      <path
        id="Vector_2"
        d="M10 0.2989C10.3586 0.2989 10.7171 0.436095 10.9916 0.710562L19.5883 9.30728C20.1372 9.8562 20.1372 10.7415 19.5883 11.2905C19.0394 11.8394 18.1541 11.8394 17.6096 11.2905L10 3.6809L2.39044 11.2905C1.84153 11.8394 0.956181 11.8394 0.411687 11.2905C-0.137228 10.7415 -0.137228 9.8562 0.411687 9.30728L9.00841 0.710562C9.28287 0.436095 9.64143 0.2989 10 0.2989Z"
        fill="var(--grey-50, #797E86)"
      />
    </g>
  </svg>
)